import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';

  .UserDocumentsAddForm {
    min-width: 500px;
    max-width: 500px;

    @include respond-to(sm) {
      min-width: 80vw;
    }

    &__error {
      margin: -15px 0 10px;
      display: block;
      width: 100%;
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css`
    .UserDocumentsAddForm {
      &__fileField {
        &--error {
          :global(.FileField__dropzone > div) {
            border-color: ${colors.error.hex} !important;
          }
        }
      }
    }

    .UserDocumentsAddForm__error {
      color: ${colors.error.hex};
    }
  `;
};

export { staticStyles, getDynamicStyles };
